export const DATE_FORMAT_STYLES = ['time', 'date', 'datetime'];
export const DURATION_FORMAT_STYLES = ['short', 'long', 'narrow'];
export function isAllowedFormatStyle(style, allowed) {
  return typeof style === 'string' && allowed.indexOf(style) !== -1;
}